<script lang="ts" setup>
import PriceLayerTable from "@/data-views/tables/price_layer/PriceLayerTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "PriceLayer",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <PriceLayerTable />
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
